import React from "react";
import "../Contactus/Contactus.css";
import Talk from "./Talk";
import Place from "./Place";

const ContactUs = () => {
  return (
    <>
    <div className="contact-us">
    <div className="full-co">
      <div className="contact-details">
        <h1>Contact</h1>
        <p>
          Mining was introduced in 1980 and has set the standard of excellence
          for mine minerals in the industry. A well-known name throughout the
          world as a symbol of quality and excellence in the mining industry.
        </p>
        <div className="help-section">
          <h2>Need help?</h2>
          <p className="call-us">
            <strong>Call Us On</strong>
            <span className="contact-number"> 000 000 0000</span>
          </p>
          <p>
            <a href="mailto:contact@mining.com" className="contact-email">
              contact@mining.com
            </a>
          </p>
        </div>
      </div>
      <div className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83930816715!2d76.81307322334798!3d28.61393912903079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd68a4748237%3A0x27eac8ae3ff9a711!2sDelhi%2C%20India!5e0!3m2!1sen!2sin!4v1638873401234!5m2!1sen!2sin"
          title="map"
          width="100%"
          height="100%"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
      </div>
    </div>

     <Place/>
    <Talk/>
    </>
  );
};

export default ContactUs;
